import * as React from "react";
import { observer } from "mobx-react";
import { Icon } from "./Icon";

@observer
export class UserIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
				<ellipse cx="23.9" cy="15" rx="8" ry="9" />
				<path d="M8.11,42c2.5-7,8.63-12,15.79-12s13.29,5,15.79,12h2.11c-2.61-8.15-9.63-14-17.9-14S8.61,33.85,6,42Z" />
			</svg>
		</Icon>;
	}
}